import log from "js/core/logger";
import { Backbone, $ } from "js/vendor";
import Thumbnails from "js/core/models/thumbnails";
import { THUMBNAIL_SIZES } from "common/constants";

let SlideItem = Backbone.View.extend({

    className: "slide_item",

    initialize(options) {
        this.index = options.index;
        this.presentation = options.presentation;
        this.thumbnailSize = options.thumbnailSize || "small";
        this.options = options;

        this.listenTo(this.model, "change:modifiedAt", () => {
            this.renderThumbnail().catch(err => {
                log.warn(err.message);
            });
        });
    },

    render() {
        this.$el.attr("data-id", this.model.id);
        this.$el.data("model", this.model);
        this.$thumbnail = $.div("thumbnail");
        this.$el.append(this.$thumbnail);
        this.renderThumbnail().catch(err => {
            log.warn(err.message);
        });
        this.renderName();
        return this;
    },

    renderName: function() {
        // void - use to override
    },

    renderSkip: function(elem) {
        elem.addClass("thumbnail-skip-corner");
        elem.prepend($.icon("visibility_off", "thumbnail-skip"));
    },

    renderThumbnail: function() {
        let presentationId;
        if (this.presentation) {
            presentationId = this.presentation.id;
        }
        if (!presentationId && this.model.presentation) {
            presentationId = this.model.presentation.id;
        }
        if (!presentationId && this.options.player && this.options.player.presentation) {
            presentationId = this.options.player.presentation.id;
        }
        if (!presentationId) {
            throw new Error("Presentation id not found");
        }

        return Thumbnails.getSignedUrlAndLoad(this.model.id, this.model.get("modifiedAt"), presentationId, THUMBNAIL_SIZES[this.thumbnailSize].suffix).then(url => {
            return new Promise((resolve, reject) => {
                let $oldImage = this.$thumbnail.find("img");
                let $image = this.$thumbnail.addEl($.img());
                $image.opacity(0);
                $image.on("load", () => {
                    $image.velocity("transition.fadeIn");
                    $oldImage.fadeOut().remove();
                    $image.addClass("loaded");
                    if (this.model.get("isSkipped")) {
                        this.renderSkip(this.$thumbnail);
                    }
                    resolve();
                });
                $image.on("error", () => {
                    reject(new Error("Invalid url " + url));
                });
                $image.attr("src", url);
            });
        }).catch(err => {
            log.error(err);
        });
    }
});

export default SlideItem;
